// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3Pa8DQ9gajj8mQ {\n  display: inline-block;\n  padding: 8px 4px;\n  padding-left: 0;\n  align-self: center;\n}\n._33AltfORLQv7FI {\n  height: 24px !important;\n  font-size: 14px;\n  line-height: 24px !important;\n  font-weight: inherit;\n  margin-top: 0 !important;\n}\n.Rvh9AbnTiNdpct {\n  height: 32px !important;\n  width: 100% !important;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 32px !important;\n  margin: 2px 0 !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardLabels": "_3Pa8DQ9gajj8mQ",
	"cardLabelOverrides": "_33AltfORLQv7FI",
	"cardLabelReadOnly": "Rvh9AbnTiNdpct"
};
export default ___CSS_LOADER_EXPORT___;
